import regNumberInputValidationSchema from "common/validation/regNumberInputValidationSchema";
import { object } from "zod";

export const partExchangeWidgetSchema = object({
    regEntry: regNumberInputValidationSchema,
});
